import React, { useContext, useEffect, useState } from 'react';
import { TechHeader } from '../../components/TechHeader';
import './index.css';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';
import TechCallContainer from '../../components/TechCallContainer';
import TechCallLeftSide from '../../components/TechCallLeftSide';
import TechCallSessionInformation from '../../components/TechCallSessionInformation';
import TechEndCallModal from '../../components/TechEndCallModal';
import MainStore from '../../stores/MainStore';
import EndCallByCustomerForTech from '../../components/EndCallByCustomerForTech';

const TechCallView = () => {

  const { showModalAlert } = useContext(ModalAlertContext);
  const [client, setClient] = useState(null);

  useEffect(() => {

    MainStore.setShowModalAlert(showModalAlert);
  }, []);

  /**
   * Handles the 'beforeunload' event to show a browser warning dialog when the user attempts to leave the page.
   * This prevents accidental navigation away from an active call session.
   */
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);


  return (
    <div className="tech-view">
      <TechHeader />
      <div className="tech-view-content">
        <TechCallLeftSide />
        <TechCallContainer setClient={setClient} />
        <TechCallSessionInformation />
        <TechEndCallModal client={client} />
        <EndCallByCustomerForTech client={client} />
      </div>
    </div>
  );
};

export default TechCallView;
